module.exports = require("core-js/library/fn/symbol/iterator");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/symbol/iterator.js
// module id = 153
// module chunks = 35783957827783 70144966829960 114276838955818 198517197184460